module.exports = __webpack_public_path__ + "static/media/rose.689d1172.svg";